import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import { formatThousands } from "@/utils/index.js";
import util from "@/libs/util";
import SourceTag from "@/views/quarter/components/SourceTag.vue";
export default {
  name: 'RefundForm',
  components: {
    SourceTag: SourceTag
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    title: String,
    content: String,
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    width: {
      type: [String, Number],
      default: 250
    },
    placement: {
      type: String,
      default: 'top'
    },
    trigger: {
      type: String,
      default: 'click'
    },
    popperClass: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: false,
      loading: false,
      rules: {
        reimburseSerialNumber: [{
          required: true,
          message: '请输入退款流水号',
          trigger: 'change'
        }],
        slip: [{
          required: true,
          message: '请上传退款回单',
          trigger: 'change'
        }]
      },
      form: {},
      subInfo: {},
      searchLoading: false,
      adminId: util.cookies.get("uuid") || ""
    };
  },
  watch: {
    'form.reimburseSerialNumber': {
      handler: function handler(nVal) {
        if (!(nVal !== null && nVal !== void 0 && nVal.trim())) {
          this.subInfo = {};
        }
      },
      immediate: true
    }
  },
  computed: {
    isAli: function isAli() {
      return this.form.dataSource === 'ALIPAY';
    }
  },
  methods: {
    formatThousands: formatThousands,
    search: function search() {
      var _this = this;
      if (!this.form.reimburseSerialNumber) return this.$message.warning("请输入退款流水号");
      this.searchLoading = true;
      this.$api.queryBankDetailByCode({
        transactionNo: this.form.reimburseSerialNumber
      }).then(function (res) {
        if (res.code === 200) {
          _this.subInfo = res.data;
        }
      }).finally(function () {
        _this.searchLoading = false;
      }).catch(function (err) {
        _this.subInfo = {};
      });
    },
    show: function show(row) {
      this.form = _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(row))), this.form);
      console.log(this.form);
      if (this.form.reimburse) this.form.slip = this.form.reimburse;
      if (this.form.status === '5' && this.form.reimburseSerialNumber) {
        this.search();
      }
      this.visible = true;
    },
    cancel: function cancel() {
      var _this2 = this;
      this.visible = false;
      this.$emit('cancel');
      this.$nextTick(function () {
        _this2.$refs['ruleForm'].resetFields();
        _this2.form = {};
        _this2.subInfo = {};
        _this2.searchLoading = false;
      });
    },
    save: function save() {
      var _this3 = this;
      this.$refs["ruleForm"].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          var fun = _this3.form.status === "2" ? "bankConfirmProcess" : "bankModifyRefund";
          var params = {
            transactionNo: _this3.form.receiptWaterNbr,
            status: "5",
            adminId: _this3.adminId,
            reimburseSerialNumber: _this3.form.reimburseSerialNumber
          };
          if (_this3.form.status === "5") {
            params.slip = _this3.form.slip;
          } else {
            params.reimburse = _this3.form.slip;
          }
          _this3.$api[fun](params).then(function (res) {
            if (res.code === 200) {
              _this3.$message.success(_this3.form.status === "2" ? "确认退款成功！" : "退款信息已修改");
              _this3.$operationLog.push({
                code: _this3.form.status === "2" ? 'confirm_refund' : 'edit_refund',
                operationType: 'payment',
                detailBatchNo: _this3.form.receiptWaterNbr
              });
            }
            _this3.$emit('confirm', _this3.form);
            _this3.visible = false;
          }).finally(function () {
            _this3.loading = false;
          });
        }
      });
    }
  }
};